<template>
  <div class="builder-desktop-view">
    <header-container :class="{ 'mb-5': editing }" />

    <img
      src="@/assets/images/checkout-builder/checkout-mobile-desktop.svg"
      class="d-none d-lg-block"
    />
    <img
      src="@/assets/images/checkout-builder/checkout-mobile-responsive.svg"
      class="d-lg-none"
    />

    <footer-container :class="{ 'mt-5': editing }" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import FooterContainer from "../container/FooterContainer.vue";
import HeaderContainer from "../container/HeaderContainer.vue";
export default {
  components: { HeaderContainer, FooterContainer },
  computed: {
    ...mapState("checkoutBuilder", ["editing"])
  }
};
</script>
